import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import supabase from '../utils/supabaseClient';
import { trackEvent } from '../utils/analytics';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    console.log('[AuthCallback] Starting auth callback process');

    const params = new URLSearchParams(location.search);
    const urlRedirect = params.get('redirect');
    const localStorageRedirect = localStorage.getItem('auth_redirect_target');

    const redirect = urlRedirect || localStorageRedirect || '/user-profile';
    const safeRedirect =
      redirect === '/auth' || redirect === '/auth/callback' ? '/user-profile' : redirect;

    if (localStorageRedirect) {
      localStorage.removeItem('auth_redirect_target');
    }

    const handleAuth = async () => {
      try {
        console.log('[AuthCallback] Checking session...');
        const codeFromSearch = params.get('code');
        const hash = window.location.hash || '';
        const hashParams = new URLSearchParams(hash.replace(/^#/, ''));
        const codeFromHash = hashParams.get('code');
        const accessTokenInHash = /(access_token=|refresh_token=)/.test(hash);

        if (codeFromSearch || codeFromHash) {
          const code = codeFromSearch || codeFromHash;
          console.log('[AuthCallback] Found authorization code, exchanging for session');
          // supabase-js v2 accepts the code string
          const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);
          if (exchangeError) {
            console.error('[AuthCallback] Code exchange error:', exchangeError);
          }
        }

        let {
          data: { session },
        } = await supabase.auth.getSession();
        console.log(
          '[AuthCallback] Session after exchange:',
          session ? 'Found session' : 'No session'
        );

        // Legacy fallback ONLY when hash carries tokens from magic-link flows
        if (!session && accessTokenInHash) {
          console.log('[AuthCallback] No session but token hash present, processing legacy hash...');
          const { data, error } = await supabase.auth.getUser();
          if (error) {
            console.error('[AuthCallback] Error getting user from hash:', error);
          } else if (data.user) {
            console.log('[AuthCallback] User found from hash:', data.user.email);
            const {
              data: { session: newSession },
            } = await supabase.auth.getSession();
            session = newSession;
          }
        }

        if (session) {
          console.log('[AuthCallback] User authenticated:', session.user.email);
          trackEvent('auth_user_authenticated', {
            user_id: session.user.id,
            email: session.user.email,
          });
          trackEvent('auth_page_redirect', { redirect_page: safeRedirect });
          navigate(safeRedirect, { replace: true });
        } else {
          console.log('[AuthCallback] No session found, redirecting to auth');
          navigate('/auth', { replace: true });
        }
      } catch (error) {
        console.error('[AuthCallback] Auth callback error:', error);
        navigate('/auth', { replace: true });
      }
    };

    handleAuth();
  }, [navigate, location.search]);

  return <div>Signing you in...</div>;
} 